import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prayas',
  templateUrl: './prayas.component.html',
  styleUrls: ['./prayas.component.css']
})
export class PrayasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
